import { render, staticRenderFns } from "./mxMask.vue?vue&type=template&id=e35ba3b8"
import script from "./mxMask.vue?vue&type=script&lang=js"
export * from "./mxMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports